import { Capacitor } from '@capacitor/core';

import type { GatePlatform } from '@powerful/data';

/**
 * Identidade do build instalado, para o gate de versão mínima (§10.15).
 *
 * ⚠️ Contrato para a T0.16: `currentBuild()` devolve o número de build real. Em nativo a fonte é
 * o `@capacitor/app` (`App.getInfo().build`), que é assíncrono e por isso não cabe aqui — a
 * leitura tem de acontecer no arranque, antes de montar o roteador, e ser injetada. Até lá, o
 * valor vem de `VITE_APP_BUILD`, definido pelo pipeline de build.
 *
 * O default `1` corresponde ao seed de `app_settings`: com ambos em 1, o gate está presente e
 * sem efeito — que é exatamente o estado desejado antes da primeira publicação.
 */
export function currentBuild(): number {
  const raw = import.meta.env.VITE_APP_BUILD;
  const parsed = Number.parseInt(String(raw ?? ''), 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
}

/** Plataforma para efeito do gate: as três chaves de `min_supported_build`. */
export function gatePlatform(): GatePlatform {
  if (!Capacitor.isNativePlatform()) return 'web';
  return Capacitor.getPlatform() === 'android' ? 'android' : 'ios';
}
